import { Card, CardContent } from "../ui/card";
import { FileText, Clock, CheckCircle, DollarSign, AlertCircle } from "lucide-react";

const StatsCards = ({ stats }) => {
  const cards = [
    { label: "Total Quotes", value: stats.total, color: "text-[#00341d]", icon: FileText, iconBg: "bg-[#00341d]/10", iconColor: "text-[#00341d]" },
    { label: "Pending", value: stats.sent, color: "text-blue-600", icon: Clock, iconBg: "bg-blue-100", iconColor: "text-blue-600" },
    { label: "Paid", value: stats.paid, color: "text-green-600", icon: CheckCircle, iconBg: "bg-green-100", iconColor: "text-green-600" },
    { label: "Balance Due", value: stats.balanceDue || 0, color: "text-orange-600", icon: AlertCircle, iconBg: "bg-orange-100", iconColor: "text-orange-600" },
    { label: "Total Value", value: `$${stats.totalValue.toLocaleString()}`, color: "text-[#d97706]", icon: DollarSign, iconBg: "bg-amber-100", iconColor: "text-[#d97706]" },
    { label: "Accepted Value", value: `$${stats.acceptedValue.toLocaleString()}`, color: "text-green-600", icon: CheckCircle, iconBg: "bg-green-100", iconColor: "text-green-600" },
    { label: "Paid Value", value: `$${stats.paidValue.toLocaleString()}`, color: "text-[#00341d]", icon: DollarSign, iconBg: "bg-emerald-100", iconColor: "text-[#00341d]" },
    { label: "A/R Outstanding", value: `$${stats.arValue.toLocaleString()}`, color: "text-blue-600", icon: Clock, iconBg: "bg-blue-100", iconColor: "text-blue-600" },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
      {cards.map((s) => (
        <Card key={s.label} className="bg-white border border-zinc-200 shadow-sm rounded-sm">
          <CardContent className="p-5">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-xs font-medium text-zinc-500 uppercase tracking-wider">{s.label}</p>
                <p className={`text-2xl font-bold mt-1 ${s.color}`}>{s.value}</p>
              </div>
              <div className={`w-10 h-10 ${s.iconBg} rounded-lg flex items-center justify-center`}>
                <s.icon className={`w-5 h-5 ${s.iconColor}`} />
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default StatsCards;
